import React, {Component} from "react";
import CanvasDraw from "react-canvas-draw";

import {
    Button,
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Label
} from "reactstrap";
import axios from 'axios';
import Loader from 'react-loader-spinner';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Guest from "layouts/Guest";
import Admin from "layouts/Admin";
import GeneralHeader from "components/Headers/GeneralHeader";

class StudentMarkedScriptView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            color: "#FF0000",
            width: 800,
            height: 1020,
            brushRadius: 2,
            lazyRadius: 1,
            upload_id: this.props.match.params.upload_id,
            images: [],
            imagesLoading: true,
            currentPage: this.props.match.params.page_number,
            currentImagePos: 0,
        };
       
        this.goToNext = this.goToNext.bind(this);
        this.getTempScripts = this.getTempScripts.bind(this);
        this.goToPrevious = this.goToPrevious.bind(this);
        this.goToPortal = this.goToPortal.bind(this);

    }
    componentDidMount() { // let's change the color randomly every 2 seconds. fun!
        // //console.log('Check Scriptview state', this.state);
        this.getTempScripts();
    }

    goToNext() {
        let current_image_pos = this.state.currentImagePos + 1;
        let current_page = Number(this.state.currentPage) + 1;
        // //console.log('clicked go to next', current_page);
        this.state.currentImagePos = current_image_pos;
        this.state.currentPage = current_page;

        this.setState({currentImagePos: current_image_pos, currentPage: current_page});
        // //console.log("checking script state", this.state.images[this.state.currentImagePos]);
        window.location.href = '/admin/student-view-script/' + this.state.upload_id + '/' + this.state.currentPage;
    }

    goToPrevious() {
        let current_image_pos = Number(this.state.currentImagePos) - 1;
        let current_page = Number(this.state.currentPage) - 1;
        // //console.log('clicked go to next', current_page);
        this.state.currentImagePos = current_image_pos;
        this.state.currentPage = current_page;

        this.setState({currentImagePos: current_image_pos, currentPage: current_page});
        // //console.log("checking script state", this.state.images[this.state.currentImagePos]);
        window.location.href = '/admin/student-view-script/' + this.state.upload_id + '/' + this.state.currentPage;
    }

    goToPortal(){
        window.location.href="https://admin.thinkdigitalacademy.org/admin/student-submission-list";
    }

    getTempScripts() {
        let token = localStorage.getItem('access_token');
        // //console.log('getting temporal scripts',token);
        let cur = this;
        axios.get('https://markerportalbackend.thinkdigitalacademy.org/api/student-temp-scripts/' + cur.props.match.params.upload_id + '/' + cur.props.match.params.page_number, {
            headers: {
                'content-type': 'application/json'
            },
        }).then(res => {
            // //console.log('current scripts', res.data);
            this.setState({images: res.data.images, student_id: res.data.student_id, imagesLoading: false, annotation: res.data.annotation});
            cur.loadableCanvas.loadSaveData(this.state.annotation);
        }).catch(error => {
            // //console.log('error', error);
        });
    }

    
    render() {
        return (
            <div>
                <ToastContainer position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover/>
                <ToastContainer/>
                <GeneralHeader/>
                <Container className="mt--7" fluid style={{marginTop:10}}>
                    <Row>
                        <Col className="order-xl-1" xl="12">
                            <Card className="bg-secondary shadow">
                                <CardHeader className="bg-white border-0">
                                    <Row>
                                        {
                                        this.state.currentPage == 1 ? <Col md={2}>
                                            <Button size="sm" color="info" type="button"
                                                onClick={
                                                    this.goToNext
                                            }>
                                                Next
                                            </Button>
                                            <Label>{
                                                'Page ' + this.state.currentPage + 'of' + this.state.images.length
                                            }</Label>
                                        </Col> : <>
                                            <Col md={4}>
                                                <Button size="sm" color="info" type="button"
                                                    onClick={
                                                        this.goToPrevious
                                                }>
                                                    Previous
                                                </Button>
                                                {
                                                this.state.currentPage != this.state.images.length && <Button size="sm" color="info" type="button"
                                                    onClick={
                                                        this.goToNext
                                                }>
                                                    Next
                                                </Button>
                                            }

                                                <Label>{
                                                    'Page ' + this.state.currentPage + 'of' + this.state.images.length
                                                }</Label>
                                            </Col>
                                            
                                        </>
                                    }<Button size="sm" color="info" type="button"
                                    onClick={
                                        this.goToPortal
                                }>
                                    Student Portal
                                </Button> </Row>
                                    
                                </CardHeader>
                                <CardBody> {
                                    this.state.imagesLoading ? <Loader type="Puff" color="#00BFFF"
                                        height={100}
                                        width={100}
                                        timeout={3000}
                                        //3 secs
                                    /> : <div>
                                        <Row>
                                            
                                            <Col md={12}>
                                                <header>Assessed Script Preview</header>
                                                <CanvasDraw disabled hideGrid
                                                    canvasWidth={
                                                        this.state.width
                                                    }
                                                    canvasHeight={
                                                        this.state.height
                                                    }
                                                    imgSrc={
                                                        `https://admin.thinkdigitalacademy.org/` + this.state.images[this.state.currentPage - 1]
                                                    }
                                                    ref={
                                                        canvasDraw => (this.loadableCanvas = canvasDraw)
                                                    }/></Col>
                                        </Row>

                                    </div>
                                } </CardBody>
                            </Card>
                        </Col>
                    </Row>

                </Container>

            </div>
        );
    }
};
export default StudentMarkedScriptView;
